import api from '@/apis/di/payrollItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Loại cán bộ thường xuyên
export const usePayrollRegularItemGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { extendFilter } = usefilterActionCombo();
  const { proxy } = getCurrentInstance();
  // func call api lấy dữ liệu combo
  const onPayrollRegularItemComboboxLoadData = (payload, row, column) => {
    payload.sort = 'payroll_item_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    let extendRegular = [{ Field: 'payroll_item_type', Value: 1 }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.filter = extendFilter(payload.filter, extendRegular);
    payload.columns = payload.columns + ',column_data_type,payroll_item_type,is_set_pk_payroll_item';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const payrollRegularItemComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã khoản lương',
        dataField: 'payroll_item_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên khoản lương',
        dataField: 'payroll_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 450,
      },
    ],
    displayField: 'payroll_item_name',
    valueField: 'payroll_item_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onPayrollRegularItemComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return { payrollRegularItemComboConfig, onPayrollRegularItemComboboxLoadData }; // trả về thêm để dùng chung cho cả combo không thuộc grid
};
